import type { OrderFlag, OrderFlagSource } from '@/api/hooks/useOrderDetails'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Tag, Tooltip } from 'antd'

interface OrderFlagChipsProps {
  flags: OrderFlag[]
}

export function OrderFlagChips({ flags }: OrderFlagChipsProps) {
  const bySource = new Map<OrderFlagSource, OrderFlag[]>()
  for (const flag of flags) {
    bySource.set(flag.source, [...(bySource.get(flag.source) ?? []), flag])
  }

  return [...bySource].map(([source, group]) => {
    const failed = group.some((flag) => flag.status === 'failed')
    return (
      <Tooltip
        key={source}
        title={
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {group.map((flag) => (
              <div key={flag.tenant}>
                <div style={{ fontWeight: 600 }}>{flag.tenant}</div>
                <div>{flag.text}</div>
              </div>
            ))}
          </div>
        }
      >
        <Tag color={failed ? 'red' : 'green'}>
          <span
            style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
          >
            {failed ? <CloseCircleOutlined /> : <CheckCircleOutlined />}
            {group[0]?.source_label}
          </span>
        </Tag>
      </Tooltip>
    )
  })
}
